import React from "react";
import { Animated } from "react-animated-css";
import { Container, Navbar, Nav, Row, Image } from 'react-bootstrap';

//Redux
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as actionCreators from '../store/actions';

import isStringArabic from '../store/isStringArabic';
import { Link } from "react-router-dom"
// IMAGES
import Menu from "../images/svgs/SocialMediaMenu/Menu.svg";
import Close01 from "../images/svgs/SocialMediaMenu/Close01.svg";
import CartIcon from "../images/svgs/cart.svg";
import MagnifierIcon from "../images/svgs/Maginifier.svg";

 class SubscribedNavbar extends React.Component {
  state = {
    menuExpaned: null
  }
  changeLanguage = () => {
    if (this.props.language === "en") {
      // this.props.history.replace("/ar")
      this.props.history.replace("/clientwebsite2/ar")

    } else {
      this.props.history.replace("/")
    }
  }
  render() {
    // const translate = this.props.translate
    const categories = this.props.categories;

    return (
      <Container className="mainHome">
        <Navbar expand={"lg"} className={`navBarBlock ${this.props.productDetail && "productDetailNavBar"}`} onToggle={(expanded) => {
          this.setState({
            menuExpaned: expanded
          })
        }}>
          <div className="innerBlock1">
            <Navbar.Toggle aria-controls="basic-navbar-nav" className={`menuBtn`}
              style={this.state.menuExpaned || this.props.bucketExpaned ? {
                position: "absolute",
                top: "5%",
                zIndex: 20,
                right: "25%",
              } : {
                  // marginLeft: 7,
                }}
            >
              <Image
                src={!this.state.menuExpaned ? Menu : Close01}
              />
            </Navbar.Toggle>
              {this.props.errorMessage && 
                <Row className="errorMessageText">
                    {this.props.errorMessage}
                </Row>
              }
          </div>
          <Row className="brandImageRowSubscribed">
						<Image className="brandImageSubscribedHeader" src={this.props.instagramAccountInfo.brandProfilePic} onError={this.errorLoadingPicture} />
					</Row>
					<Row
						className="brandNameTextSubscribed"
						style={{
							fontFamily: isStringArabic(this.props.instagramAccountInfo.brandName)
								? 'Changa-semibold'
								: 'Montserrat-medium',
						}}
					>
						{this.props.instagramAccountInfo.brandName}
					</Row>
          
				
          {
            this.props.instagramAccountInfo.businessName !== "shaheenmusic" &&           
            <Animated
              animationIn="slideInLeft"
              animationOut="slideOutLeft"
              isVisible={this.state.menuExpaned || window.innerWidth >= 1024}
              className="categoryButtons"
            >
              <Navbar.Collapse id="responsive-navbar-nav" className={"navBarCollapse"} >
                {
                  this.state.menuExpaned && <div className="navBarHeader">
                    <Image className="brandImage" src={this.props.instagramAccountInfo.brandProfilePic} onError={this.errorLoadingPicture} />
                    <p style={{
                      fontFamily: isStringArabic(this.props.instagramAccountInfo.brandName)
                        ? 'Changa-bold'
                        : 'Montserrat-bold',
                    }}
                    >
                      {this.props.instagramAccountInfo.brandName}
                    </p>
                  </div>
                }
                <Nav.Link
                  as={Link}
                  to={`/clientwebsite2`}
                  rel="noopener noreferrer"
                  className={"subscribeNavLink"}
                >
                  <p className={`categoryNavbarName ${this.props.language === "ar" && "arabic"}`}>HOME</p>

                </Nav.Link>
                
                {
                  categories && categories.length > 0 && categories.map(category =>
                    <Nav.Link
                      key={category.id}
                      as={Link}
                      to={`/clientwebsite2/category/${category.id}`}
                      rel="noopener noreferrer"
                      id={category.id}
                      className={"subscribeNavLink"}
                    >
                      <p className={`categoryNavbarName ${this.props.language === "ar" && "arabic"}`}>{category.name}</p>

                    </Nav.Link>
                  )
                }
              </Navbar.Collapse>
            </Animated>
          }
         	<p onClick={this.props.changeLanguage} className={`languageButton ${this.props.language === "en" && "arabic"} ${this.props.language === "ar" && " languageButtonRTL"}`} >
						{this.props.language === "en" ? "العربية" : "En"}
					</p>
          <div className={"myCartBtn"} onClick={this.props.expandBucket}>
            <Image
              className={"myCartIcon"}
              src={CartIcon}
            />
            <p className={"cartListLength"}>
              {this.props.cartList && this.props.cartList.length > 0 && this.props.cartList.length}
            </p>
          </div>


        </Navbar>
        <div className={`searchBox ${this.props.productDetail && "productDetailSearchBar"}`}>
          <Image className={"magnifierIcon"} src={MagnifierIcon} />
            <input className="searchBoxInput" placeholder={"Search items..."}
                onChange={(e) => {
                  this.props.filterProductsByName( e.target.value)
                }}
            />
        </div>
      </Container>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  filterProductsByName:(query) => dispatch(actionCreators.filterProductsByName(query))
});
const mapStateToProps = state => ({
	language: state.websiteLanguage.language,
	instagramAccountInfo: state.campaign.instagramAccountInfo,
	errorMessage: state.campaign.errorMessage,
	loadingInstaDetail: state.campaign.loadingInstaDetail,
	no_of_products_to_show: state.campaign.no_of_products_to_show,
	pathname: state.login.pathname,
	translate: state.websiteLanguage.translations,
	featuredProductsList: state.campaign.featuredProductsList,
	popularProductsList: state.campaign.popularProductsList,
	explore_products: state.campaign.explore_products,
	currency: state.login.currency,
	cartList: state.cart.cartList,
	categories: state.campaign.categories
});
export default withRouter(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(SubscribedNavbar)
);



// WEBPACK FOOTER //
// ./src/components/SubscribedNavbar.js